<template>
  <div class="common-box">
    <!-- <el-form
      inline
      ref="form"
      class="search-form common-box-search-form"
      label-position="right"
      :model="form"
      label-width="70px"
    >
      <search-form @search="handleSearch" @refresh="handleRefresh">
        <div slot="content">
          <el-form-item label="客户名称：">
            <el-input
              @change="handleSearchListData"
              size="mini"
              v-model.trim="form.contactsName"
              placeholder="请输入客户名称"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="客户电话：">
            <el-input
              @change="handleSearchListData"
              size="mini"
              v-model.trim="form.contactsPhone"
              placeholder="请输入客户电话"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="信用代码：">
            <el-input
              @change="handleSearchListData"
              size="mini"
              v-model.trim="form.creditCode"
              placeholder="请输入信用代码"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="单位名称：">
            <el-input
              @change="handleSearchListData"
              size="mini"
              v-model.trim="form.termName"
              placeholder="请输入单位名称"
              clearable
            ></el-input>
          </el-form-item>
        </div>
      </search-form>
    </el-form> -->
    <!-- <div class="common-cover-div"></div> -->
    <div class="operation-and-table__container" style="top: 0">
      <div class="btns__container">
        <el-button
          size="mini"
          type="primary"
          class="plr28"
          @click="handleAdd"
        >添加</el-button>
        <el-button
          size="mini"
          type="primary"
          class="plr28"
          @click="handleDelete"
          plain
        >删除</el-button>
        <el-button
          size="mini"
          type="primary"
          @click="exportTerm"
          plain
          class="plr28"
        >导出</el-button>
      </div>
      <div class="table__container">
        <el-table
          v-loading="tableLoading"
          :data="list"
          height="100%"
          border
          style="width: 100%"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="40"></el-table-column>
          <el-table-column type="index" label="序号" width="98"></el-table-column>
          <el-table-column show-overflow-tooltip prop="itemName" label="保养项目" width="150"></el-table-column>
          <el-table-column show-overflow-tooltip prop="maintainTypeName" label="保养类型" width="150"></el-table-column>
          <!-- <el-table-column show-overflow-tooltip prop="contactsName" label="保养项内容" width="150"></el-table-column> -->
          <el-table-column show-overflow-tooltip prop="maintainLocationName" label="保养位置" width="150"></el-table-column>
          <el-table-column show-overflow-tooltip prop="requirements" label="保养要求" width="200"></el-table-column>
          <el-table-column show-overflow-tooltip prop="optionalStatus" label="是否必填" width="150">
            <template slot-scope="scope">
              {{scope.row.optionalStatus == 1 ? "必填" : "可选"}}
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="sortOrder" label="排序号" width="150"></el-table-column>
          <el-table-column label=" " prop=" "></el-table-column>
          <el-table-column label="操作" width="98px" fixed="right">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="text"
                @click="handleEdit(scope.row)"
              >编辑</el-button>
              <div class="btn-divide"></div>
              <el-button
                size="mini"
                type="text"
                @click="handleDeleteTerm(scope.row)"
              >删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagenation__container">
        <div class="for-fff-bg">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageIndex"
            :page-sizes="[25, 50, 100, 150, 200]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
        </div>
      </div>
    </div>
    <add-term
      :templateId="templateId"
      v-if="addTermVisible"
      @cancel="addTermVisible = false"
      @confirm="handleAddTermConfirm"
    ></add-term>
    <edit-term
      :templateId="templateId"
      v-if="editTermVisible"
      :editData="termDetail"
      @cancel="editTermVisible = false"
      @confirm="handleEditTermConfirm"
    ></edit-term>
  </div>
</template>

<script>
import { getTermList, deleteTerm, exportTerm } from "@/api/MaintenanceItems";

import AddTerm from "./components/AddTerm";
import EditTerm from "./components/EditTerm";
export default {
  name: "MaintenanceItems",
  components: {
    AddTerm,
    EditTerm
  },
  data() {
    return {
      form: {
        contactsName: "",
        contactsPhone: "",
        creditCode: "",
        termName: "",
      },
      tableLoading: false,
      list: [],
      multipleSelection: [],
      pageIndex: 1,
      pageSize: 50,
      total: 0,
      addTermVisible: false,
      editTermVisible: false,
      termDetail: {},
      templateId: ''
    };
  },
  computed: {
    hasRole: function () {
      return this.$store.getters["common/promise/getRole"](this.$route.path);
    },
  },
  created() {
    this.templateId = this.$route.params.templateId
    this.getListData();
  },
  methods: {
    async getListData() {
      this.tableLoading = true;
      const params = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        templateId: this.templateId
      };
      for (let key in this.form) {
        if (this.form[key]) params[key] = this.form[key];
      }
      const res = await getTermList(params);
      if (res.code === 200) {
        this.total = res.data.total;
        this.list = res.data.list;
      }
      this.tableLoading = false;
    },
    handleSearch() {
      this.pageIndex = 1;
      this.getListData();
    },
    handleRefresh() {
      for (let key in this.form) {
        if (Array.isArray(this.form[key])) {
          this.form[key] = [];
        } else {
          this.form[key] = "";
        }
      }
      this.pageIndex = 1;
      this.getListData();
    },
    handleSearchListData() {
      this.pageIndex = 1;
      this.getListData();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleDeleteTerm(row) {
      const idList = [row.id];
      this.deleteTerm(idList);
    },
    handleEdit(row) {
      this.termDetail = row;
      this.editTermVisible = true;
    },
    handleDelete() {
      if (!this.multipleSelection.length) {
        this.$message.warning("请选择要删除的行");
        return;
      }
      const idList = this.multipleSelection.map((item) => item.id);
      this.deleteTerm(idList);
    },
    deleteTerm(idList) {
      this.$confirm("确定删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const res = await deleteTerm({ idList });
          if (res.code === 200) {
            this.$message.success("删除成功");
            this.getListData();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleAdd() {
      this.addTermVisible = true;
    },
    exportTerm() {
      const params = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
      };
      for (let key in this.form) {
        if (this.form[key]) params[key] = this.form[key];
      }
      exportTerm(params);
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getListData();
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getListData();
    },
    handleAddTermConfirm() {
      this.addTermVisible = false;
      this.pageIndex = 1;
      this.getListData();
    },
    handleEditTermConfirm() {
      this.editTermVisible = false;
      this.getListData();
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/MaintenanceItems/MaintenanceItems.vue